import { createStyles } from '@material-ui/core';

const styles = () =>
  createStyles({
    container: {
      display: 'grid',
      gridTemplateRows: '0fr',
      opacity: 0,
      transition: 'grid-template-rows 800ms, opacity 800ms',
      '& > div': {
        overflow: 'hidden',
      },
    },
    expand: {
      gridTemplateRows: '1fr',
      opacity: 1,
    },
  });

export default styles;
